"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedPaymentMethodClient = void 0;
var tslib_1 = require("tslib");
var commerce_core_1 = require("@broadleaf/commerce-core");
var types_1 = require("./types");
/**
 * Client used for interacting with the SavedPaymentMethod APIs.
 */
var SavedPaymentMethodClient = /** @class */ (function (_super) {
    tslib_1.__extends(SavedPaymentMethodClient, _super);
    function SavedPaymentMethodClient(options) {
        return _super.call(this, tslib_1.__assign(tslib_1.__assign({}, options), { basePath: options.basePath || '/api/payment' })) || this;
    }
    /**
     * Retrieves a page of saved payment methods based on the owning user type and id.
     * For example, to retrieve customer saved payment methods, we'd pass in BLC_CUSTOMER and customer id.
     *
     * @param owningUserType the type of the owning user which owns the saved payment methods
     * @param owningUserId the owning user id which owns the saved payment methods
     * @param options the options to the HTTP call
     * @return a page of saved payment methods
     */
    SavedPaymentMethodClient.prototype.listSavedPaymentMethods = function (owningUserType, owningUserId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.getSavedPaymentMethodUriByOwningUserType(owningUserType);
                        config = {
                            method: 'get',
                            url: uri + "/" + owningUserId + "/saved-payment-methods",
                            params: {}
                        };
                        this.attachPageableParamsIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Retrieves a saved payment method for the given owner.
     *
     * @param owningUserType the type of the owning user which owns the saved payment method
     * @param owningUserId the owning user id which owns the saved payment method
     * @param savedPaymentMethodId the saved payment method id to retrieve
     * @param options the options to the HTTP call
     * @return a saved payment
     */
    SavedPaymentMethodClient.prototype.getSavedPaymentMethod = function (owningUserType, owningUserId, savedPaymentMethodId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.getSavedPaymentMethodUriByOwningUserType(owningUserType);
                        config = {
                            method: 'get',
                            url: uri + "/" + owningUserId + "/saved-payment-methods/" + savedPaymentMethodId
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Adds a saved payment method to the given owner.
     *
     * @param createSavedPaymentMethodRequest
     * @param options the options to the HTTP call
     * @return the new saved payment method summary
     */
    SavedPaymentMethodClient.prototype.addSavedPaymentMethod = function (createSavedPaymentMethodRequest, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var owningUserType, owningUserId, uri, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        owningUserType = createSavedPaymentMethodRequest.owningUserType;
                        owningUserId = createSavedPaymentMethodRequest.owningUserId;
                        uri = this.getSavedPaymentMethodUriByOwningUserType(owningUserType);
                        config = {
                            method: 'post',
                            url: uri + "/" + owningUserId + "/saved-payment-methods",
                            data: createSavedPaymentMethodRequest
                        };
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Updates a saved payment method for the given owner.
     *
     * @param owningUserType the type of the owning user which owns the saved payment method
     * @param owningUserId the owning user id which owns the saved payment method
     * @param updateSavedPaymentMethodRequest
     * @param options the options to the HTTP call
     * @return the updated saved payment method summary
     */
    SavedPaymentMethodClient.prototype.updateSavedPaymentMethod = function (owningUserType, owningUserId, updateSavedPaymentMethodRequest, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, savedPaymentMethodId, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.getSavedPaymentMethodUriByOwningUserType(owningUserType);
                        savedPaymentMethodId = updateSavedPaymentMethodRequest.id;
                        config = {
                            method: 'patch',
                            url: uri + "/" + owningUserId + "/saved-payment-methods/" + savedPaymentMethodId,
                            data: updateSavedPaymentMethodRequest
                        };
                        this.attachSavedPaymentVersionHeaderIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Deletes a saved payment method for the given owner.
     *
     * @param owningUserType the type of the owning user which owns the saved payment method
     * @param owningUserId the owning user id which owns the saved payment method
     * @param savedPaymentMethodId the saved payment method id to delete
     * @param options the options to the HTTP call
     */
    SavedPaymentMethodClient.prototype.deleteSavedPaymentMethod = function (owningUserType, owningUserId, savedPaymentMethodId, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, config, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uri = this.getSavedPaymentMethodUriByOwningUserType(owningUserType);
                        config = {
                            method: 'delete',
                            url: uri + "/" + owningUserId + "/saved-payment-methods/" + savedPaymentMethodId
                        };
                        this.attachSavedPaymentVersionHeaderIfPresent(config, options);
                        return [4 /*yield*/, this.call(config, options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
                }
            });
        });
    };
    /**
     * Gets the saved payment method uri for the given saved payment method owning user type.
     *
     * @param owningUserType the saved payment method uri for the given saved payment method owning user type
     */
    SavedPaymentMethodClient.prototype.getSavedPaymentMethodUriByOwningUserType = function (owningUserType) {
        if (owningUserType === types_1.DefaultSavedPaymentMethodOwningUserType.BLC_ACCOUNT) {
            return '/accounts';
        }
        return '/customers';
    };
    /**
     * Attaches the saved payment method version header to the request `config` if present on `options`.
     *
     * @param config The axios request config to modify
     * @param options Options specifying additional parameters to be used to modify the `config`
     */
    SavedPaymentMethodClient.prototype.attachSavedPaymentVersionHeaderIfPresent = function (config, options) {
        if ((options === null || options === void 0 ? void 0 : options.version) !== undefined) {
            if (!config.headers) {
                config.headers = {};
            }
            config.headers['X-SavedPayment-Version'] = String(options.version);
        }
    };
    /**
     * Attaches pageable params (size, sort, etc.) to the request `config` if present on `options`.
     *
     * @param config The axios request config to modify
     * @param options Options specifying additional parameters to be used to modify the `config`
     */
    SavedPaymentMethodClient.prototype.attachPageableParamsIfPresent = function (config, options) {
        if (options) {
            var page = options.page, size = options.size, sort = options.sort;
            if (page || page === 0) {
                config.params.page = page;
            }
            if (size || size === 0) {
                config.params.size = size;
            }
            if (sort) {
                config.params.sort = sort;
            }
        }
    };
    return SavedPaymentMethodClient;
}(commerce_core_1.AbstractClient));
exports.SavedPaymentMethodClient = SavedPaymentMethodClient;
//# sourceMappingURL=saved-payment-method-client.js.map